
import React from "react";
import GPATable from "./academicAssessmentTables/GPATable";
import ScoreTable from "./academicAssessmentTables/ScoreTable";
import CoursesTable from "./academicAssessmentTables/CoursesTable";
import CollegeTable from "./academicAssessmentTables/CollegeTable";
import Recommendation from "./academicAssessmentTables/Recommendation";
import Colleges from "./colleges";
import GlobalCollegeList from "../../../pages/common/globalcollegelist";
import style from "./academicAssessmentTables/academicAssessment.module.css"

export const COURSE_TYPES = {
  'sat': 'sat',
  'apcourse': 'apcourse',
  'hrcourse': 'hrcourse',
}
export default function AcademicAssessment({ slug, isProfile = false}) {

  return (
    <div className="settings-widget">
      <div className="settings-inner-blk p-0">
        <div className="ms-3 mt-3 mb-3">
            <h4>SAT</h4>
        </div>
        <div className={`${style.recommendationContainer}`}>
           {/*}
        <div className={`${style.assessmentTableContainer}`}>
         
          <div>
            <GPATable slug={slug} isProfile={isProfile}/>
          </div>
          {*/}
          <div>
            <ScoreTable slug={slug} isProfile={isProfile}/>
          </div>
          {/*}
          <div>
            <CoursesTable slug={slug} isProfile={isProfile}/>
          </div>
          <div>
            <CollegeTable slug={slug} isProfile={isProfile}/>
          </div>
          {*/}
          <div className={`${style.recommendationContainer}`}>
            <Recommendation slug={slug} isProfile={isProfile}/>
          </div>
        </div>
        {!isProfile && (
        <>
          {/*}<Colleges slug={slug} />  */}
          {/*}<GlobalCollegeList slug={slug} isStudent={false} />*/}
        </>
      )}
      </div>
    </div>
  );
}
